<template>
  <div class="attachment">
    <label v-if="showOutcomes" class="form-control-label">Outcomes & Expressions:</label>
    <div v-for="outcome in currentNode.outcomes" :key="outcome.id">

      <div class="form-group">
        <input @input="updateOutcome($event.target.value, outcome.id)" :value="outcome.text" type="text" class="form-control form-control-sm mb-2">
        <input @input="updateExpression($event.target.value, outcome.id)" :value="outcome.expression" type="text" class="form-control form-control-sm mb-2" placeholder="Expression Field">
        <b-button variant="danger" size="sm" @click="deleteOutcome(outcome.id)"><icon name="trash" /></b-button>
      </div>

    </div>

    <div class="form-group">
      <label class="form-control-label">Add outcome</label>
      <input v-model="newOutcome" type="text" class="form-control form-control-sm mb-2" placeholder="Outcome label">
      <input v-model="expression" type="text" class="form-control form-control-sm mb-2" placeholder="Expression">
      <b-button @click="addOutcome" size="sm" variant="success"><icon name="plus" /></b-button>
    </div>

  </div>
</template>

<script>
import { formBase, outcomeMixin } from './mixins'

export default {
  mixins: [formBase, outcomeMixin],
  data() {
    return {
      expression: '',
    }
  },
  methods: {
    addOutcome() {
      let currentNode = Object.assign({}, this.currentNode)
      
      if (!currentNode.hasOwnProperty('outcomes')) {
        currentNode['outcomes'] = []
      }

      if (this.newOutcome) {
        currentNode.outcomes.push({
          text: this.newOutcome, 
          id: 'outcome' + +new Date, 
          idx: currentNode.outcomes.length + 1, 
          expression: this.expression 
        })
        this.newOutcome = ''
        this.expression = ''
        this.updateNode(currentNode)
        this.$nextTick( () => this.updateCounter() )
      }
      
      // this is simply to force form re-render, why it doesn't re-render either way? 
      this.$nextTick(() => {
        this.setCurrentNode(currentNode.id)
      })
    },
    updateExpression(val, id) {
      let currentNode = Object.assign({}, this.currentNode)
      let index = currentNode.outcomes.findIndex(outcome => outcome.id === id)
      currentNode.outcomes[index].expression = val
      this.updateNode(currentNode)
      this.$nextTick( () => this.updateCounter() )
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-with-icon{
    display: flex;
    align-items: center;
  }
</style>